import { render, staticRenderFns } from "./CustomerImportDoneState.vue?vue&type=template&id=f59e90a2&scoped=true"
import script from "./CustomerImportDoneState.vue?vue&type=script&lang=js"
export * from "./CustomerImportDoneState.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f59e90a2",
  null
  
)

export default component.exports